import axios from 'axios';
import { loadScript } from '../utils/util';
import dotenv from 'dotenv';

dotenv.config()

console.log(dotenv.config())

const URA=process.env.REACT_APP_BASE_URL

const url=URA;


export const authenticateLogin = async (user) => {
    try {
        return await axios.post(`${url}/login`, user)
    } catch (error) {
        console.log('Error while calling login API: ', error);
    }
}

export const authenticateSignup = async (user) => {
    try {
        return await axios.post(`${url}/signup`, user)
    } catch (error) {
        console.log('Error while calling Signup API: ', error);
    }
}


export   const  showRazorpay=async(dueamount)=> {
    console.log(dueamount);
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const data = await fetch(`${url}/razorpay`, {
      method: "POST",
      body: JSON.stringify({
        amount:parseInt(dueamount,10)
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      
    }).then((t) => t.json());

    console.log(data);

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      currency: data.currency,
      amount: data.amount.toString(),
      order_id: data.id,
      name: "Total Amount",
      description: "Thank you for nothing. Please give us some money",
      image: `${url}/logo.svg`,
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        // alert(response.razorpay_order_id);
        // alert(response.razorpay_signature);

        alert("Transaction successful");
      },
      prefill: {
        name: "shivam",
        email: "shivam@kumar.com",
        phone_number: "9899999999",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

